import orderlogo from '../../order.jpg';
import { Helmet } from 'react-helmet-async';
import {Link} from 'react-router-dom';
import Sidebar from './sidebar';
import { Loader, MoreVertical, Plus} from 'react-feather';
import React,{ useState,useEffect } from 'react';
import api from "../api";
import useStoreSetupCheck from './useStoreSetupCheck';
import FileUploadComponent from './FileUploadComponent';
import { FaCashRegister, FaPlus } from 'react-icons/fa';
function SellerOrders(){
    useStoreSetupCheck();
    const [OrderItems,setOrderItems]=useState([]);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [statsLoading, setstatsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [VendorCurrency,setVendorCurrency]=useState([]); 
    
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [count, setCount] = useState(0);


    const token = localStorage.getItem("access_token");

    const [stats, setStats] = useState({
        units_sold: 0,
        total_sales: 0,
        lifetime_revenue: 0,
    });
    const [filter, setFilter] = useState("week");

    useEffect(() => {
        fetchStats(filter);
    }, [filter]);

    useEffect(() => {
        const delay = setTimeout(() => {
            setSearchTerm(searchInput.trim().toLowerCase());
        }, 300); // debounce

        return () => clearTimeout(delay);
    }, [searchInput]);

    const fetchStats = async (filterOption) => {
        setstatsLoading(true);
        try {
            const response = await api.get(`/vendor-sales-stats/?filter=${filterOption}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
            });
            setStats(response.data);
            setstatsLoading(false);
        } catch (error) {
            //console.error("Error fetching stats:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(1, filter);
    }, [filter]);

    const fetchData = async (pageNumber = 1, filterOption = filter) => {
        try {
            const response = await api.get(
                `${baseUrl}/vendor-orderitems/?page=${pageNumber}&filter=${filterOption}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            if (response.data?.results) {
                const res = response.data.results;

                setVendorCurrency(res.vendor_currency);
                setOrderItems(res.order_items);

                setCount(response.data.count);
                setPage(pageNumber);

                const pageSize = res.page_size || 40;;
                setTotalPages(Math.ceil(response.data.count / pageSize));
            }
        } catch (err) {
            setError("Failed to fetch orders");
        } finally {
            setLoading(false);
        }
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleDateString('en-US', { month: 'short' }); // "Nov"
        const day = date.getDate(); // 1
        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase(); // "11:01 pm"
    
        return `${month} ${day}, ${time.replace(':', '.')}`; // "Nov 01 11.01pm"
    }
    // Filter quotations based on the search term
    const filteredResults = OrderItems.filter((item) => {
        const search = searchTerm;

        const name = item.order?.cust_name?.toLowerCase() || "";
        const amount = String(item.order?.total_amount || "");
        const orderId = String(item.order?.order_id || "");

        return (
            name.includes(search) ||
            amount.includes(search) ||
            orderId.includes(search)
        );
    });
    return (
        <>                           
            <Helmet>
                <title>Orders</title>
                <meta name="description" content={`Orders`} />
            </Helmet>
            <section className="container mtopcon dashb">         
                <div className="row">
                    
                <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max orderscontainer">
                            <div className="row mb-3 ph-header-con">
                                <div className="col-12 pt-2"><h6 className="pageheader-title mb-3">Orders Overview </h6></div>
                            </div>
                            <div className="mb-4">
                                <div className="btn-group">
                                    {[
                                    { label: "Today", value: "today" },
                                    { label: "Week", value: "week" },
                                    { label: "Month", value: "month" },
                                    { label: "Year", value: "year" },
                                    { label: "All Orders", value: "all" }
                                    ].map((f) => (
                                    <button
                                        key={f.value}
                                        className={`btn btn-sm font8 ${filter === f.value ? "btn-dark" : "btn-outline-dark"}`}
                                        onClick={() => setFilter(f.value)}
                                    >
                                        {f.label}
                                    </button>
                                    ))}
                                </div>
                            </div>
                            
                            <div className="row g-2 ordststsdiv mb-4">

                                {/* Total Sales */}
                                <div className="col-lg-3 col-md-6 col-6">
                                    <div className="stat-tile bg-soft-purple">
                                        <div>
                                            <p className="stat-label">Revenue</p>
                                            <h3 className="stat-value">
                                                <span className='hdmobilev'>{VendorCurrency}</span>{" "}
                                                {parseFloat(stats.total_sales.toFixed(2)).toLocaleString()}
                                            </h3>
                                        </div>

                                        <div className="stat-meta">
                                            {stats.total_sales_deviation >= '0%' ? (
                                                <span className='text-success'>+{stats.total_sales_deviation}</span>
                                            ) : (
                                                <span className='text-danger'>{stats.total_sales_deviation}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Units Sold */}
                                <div className="col-lg-3 col-md-6 col-6">
                                    <div className="stat-tile bg-soft-orange">
                                        <div>
                                            <p className="stat-label">Units Sold</p>
                                            <h3 className="stat-value">{stats.units_sold}</h3>
                                        </div>

                                        <div className="stat-meta">
                                            {stats.units_sold_deviation >= '0%' ? (
                                                <span className='text-success'>+{stats.units_sold_deviation}</span>
                                            ) : (
                                                <span className='text-danger'>{stats.units_sold_deviation}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* New Customers */}
                                <div className="col-lg-3 col-md-6 col-6">
                                    <div className="stat-tile bg-soft-green">
                                        <div>
                                            <p className="stat-label">Customers</p>
                                            <h3 className="stat-value">{stats.unique_customers}</h3>
                                        </div>

                                        <div className="stat-meta">
                                            {stats.unique_customers_deviation >= '0%' ? (
                                                <span className='text-success'>+{stats.unique_customers_deviation}</span>
                                            ) : (
                                                <span className='text-danger'>{stats.unique_customers_deviation}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Lifetime Revenue */}
                                <div className="col-lg-3 col-md-6 col-6 pointer" data-bs-toggle="modal" data-bs-target="#addorder">
                                    <div className="stat-tile bg-dark text-white">
                                        <div>
                                            <div className="text-white"><Plus/> Upload</div>
                                            <p className="stat-label text-white">Excel or Csv orders</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <input
                                        className="filter2 border me-2 w-100"
                                        type="search"
                                        placeholder="Search by name, amount, or order ID..."
                                        aria-label="Search Orders"
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-2 ph-header-con">
                                <div className="col-8 pt-2"><h6 className="pageheader-title mb-3">Recent Orders </h6></div>
                            </div>

                            <div className="mb-4">
                                {loading ? (
                                    <p className="text-center py-4">Loading...</p>
                                ) : filteredResults.length === 0 ? (
                                    <div className="text-center py-5 bg-inherit rounded shadow-0">

                                        <h6 className="mb-2">No orders found</h6>
                                        <p className="text-muted mb-4">
                                            No orders match your current selection. Try adjusting your filters, upload past orders or start selling to unlock insights.
                                        </p>

                                        <div className="d-flex justify-content-center gap-2 flex-wrap">

                                            {/* POS Add Order */}
                                            <Link to="/seller/pos">
                                                <button className="btn btn-outline-dark pt-2 pb-2 pr-3 pl-3 br10">
                                                    <FaCashRegister className='me-1'/> Add Order (POS)
                                                </button>
                                            </Link>

                                            {/* Upload Orders */}
                                            <Link  data-bs-toggle="modal" data-bs-target="#addorder">
                                                <button className="btn btn-dark pt-2 pb-2 pr-3 pl-3 br10">
                                                   <FaPlus/> Upload Orders
                                                </button>
                                            </Link>

                                        </div>

                                    </div>
                                ) : (
                                    filteredResults.map((item, index) => {
                                        const isUploaded = item.is_uploaded;

                                        return (
                                            <Link
                                                to={isUploaded ? "#" : `/seller/order/${item.order.order_id}`}
                                                className="text-dark"
                                                key={index}
                                            >
                                                <div className="row ord-bg bg-white p-2 pointer hvr bx-shadow">
                                                    <div className="col-2 col-lg-1 p-0">
                                                        <div className="ord-img br-10">
                                                            <img src={orderlogo} className='w-100 h-100' alt="Order logo" />
                                                        </div>
                                                    </div>
                                                    <div className="col-9 col-lg-11 pl-0 p-0">
                                                        <div className="row">
                                                            <div className="col-7 col-lg-3 ord-sz">
                                                                {item.order.cust_name || "Walk-in"}
                                                            </div>

                                                            <div className="col-5 col-lg-3 ord-sz text-primary">
                                                                {isUploaded ? (
                                                                    <span className="badge bg-secondary">Uploaded</span>
                                                                ) : item.order.order_status ? (
                                                                    <span className="badge text-success bg-success-subtle">Complete</span>
                                                                ) : (
                                                                    <span className="badge text-bg-warning">
                                                                        {item.order.payment_status}
                                                                    </span>
                                                                )}
                                                            </div>

                                                            <div className="col-7 col-lg-3 ord-sz grey-text">
                                                                {formatDate(item.order.order_time)}
                                                            </div>

                                                            <div className="col-5 col-lg-3 ord-sz grey-text">
                                                                {item.product?.currency}{" "}
                                                                {parseFloat(item.order.total_amount).toLocaleString()}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </Link>
                                        );
                                    })
                                )}
                            </div>
                            
                            <div className="pagination-container mt-4 text-center">
                                {totalPages > 1 && (
                                    <nav aria-label="Orders pagination">
                                    <ul className="pagination justify-content-center">

                                        {/* Prev */}
                                        <li
                                            className={`page-item ${page === 1 ? "disabled" : ""}`}
                                            onClick={() => page > 1 && fetchData(page - 1)}
                                        >
                                            <span className="page-link pointer">← Prev</span>
                                        </li>

                                        {/* Pages */}
                                        {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((num) => (
                                        <li
                                            key={num}
                                            className={`page-item ${page === num ? "active" : ""}`}
                                            onClick={() => fetchData(num)}
                                        >
                                            <span className="page-link pointer">{num}</span>
                                        </li>
                                        ))}

                                        {/* Next */}
                                        <li
                                            className={`page-item ${page === totalPages ? "disabled" : ""}`}
                                            onClick={() => page < totalPages && fetchData(page + 1)}
                                        >
                                            <span className="page-link pointer">Next →</span>
                                        </li>

                                    </ul>
                                    </nav>
                                )}
                            </div>

                            
                    </div>
                </div>
            </section>
            <div
                className="modal fade"
                id="addorder"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog mt70">
                <div className="modal-content">
                    <div className="modal-body">
                    <div>
                        <FileUploadComponent/>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}

export default SellerOrders;